import { AppointmentPractitioner } from '@dreryk/egabinet-appointment-frontend-api';

import { useFormController } from '@dreryk/react-common';
import { Select } from '@dreryk/react-components';

import { usePractitionerSelectorState } from './PractitionerSelector.hooks';
import { PractitionerSelectorFormBean } from './PractitionerSelector.types';
import { triggerLabelExtractor } from './PractitionerSelector.utils';
import { PractitionerSelectorList } from './PractitionerSelectorList';

type PractitionerSelectorProps = {
   readonly selectedPractitioner: AppointmentPractitioner;
   readonly practitioners: AppointmentPractitioner[];
   readonly onChange: (practitioner: AppointmentPractitioner) => void;
};

export const PractitionerSelector = (props: PractitionerSelectorProps): JSX.Element => {
   const { register } = useFormController<PractitionerSelectorFormBean>({
      practitioner: props.selectedPractitioner,
   });

   if (props.practitioners.length <= 1) {
      return <></>;
   }

   return (
      <Select<AppointmentPractitioner>
         testId={'practitioner'}
         controller={register('practitioner')}
         triggerLabelExtractor={triggerLabelExtractor}
         onSelect={(practitioner) => props.onChange(practitioner!)}
         searchInputEnabled
         compact
      >
         <PractitionerSelectorList practitioners={props.practitioners} />
      </Select>
   );
};

PractitionerSelector.useState = usePractitionerSelectorState;
